import React from "react";
import { usePromptStore } from "../../../store/promptStore";
import FieldContainer from "./FieldContainer";
import CheckboxInput from "../../dynamic/CheckboxInput";
import { PromptRequest, PromptTypeKey } from "../../../types/promptTypes";

interface CheckboxFieldProps {
  index: number;
}

const CheckboxField: React.FC<CheckboxFieldProps> = ({ index }) => {
  const prompts = usePromptStore((state) => state.prompts);
  const promptValues = usePromptStore((state) => state.promptValues);
  const setPromptValue = usePromptStore((state) => state.setPromptValue);

  const prompt = prompts[index] as PromptRequest<PromptTypeKey.CHECKBOX>;
  const attributes = prompt.attributes;

  // Parse current selection from JSON string
  const selectedValues = promptValues[index] ? promptValues[index] : [];

  const handleChange = (values: string[]) => {
    setPromptValue(index, values);
  };

  return (
    <FieldContainer field={prompt}>
      <CheckboxInput
        options={attributes.options}
        selectedValues={selectedValues}
        multiple={attributes.multiple || false}
        onChange={handleChange}
      />
    </FieldContainer>
  );
};

export default CheckboxField;
